import { render, staticRenderFns } from "./downloadCenter.vue?vue&type=template&id=a2a94a60&scoped=true"
import script from "./downloadCenter.vue?vue&type=script&lang=js"
export * from "./downloadCenter.vue?vue&type=script&lang=js"
import style0 from "./downloadCenter.vue?vue&type=style&index=0&id=a2a94a60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a94a60",
  null
  
)

export default component.exports